export default "__VITE_ASSET__ClPdSkiy__"